import {
    signTypes
} from '../types';
import {
    signIn,
    recoveryPassword,
    register,
    setPassword,
    signOut,
} from '../services/sign';
import { getToken } from 'helpers';
import { getData } from './account';
import { allClear } from './app'

export const changeTab = (tab) => async (dispatch) => {
    dispatch({
        type: signTypes.TABS_CHANGE,
        tab,
    });
};

export const setLoginMode = (loginMode) => async (dispatch) => {
    dispatch({
        type: signTypes.LOGIN_VIEW_CHANGE,
        loginMode,
        tab: 'login'
    });
};

export const checkLoggedStatus = () => async (dispatch) => {
    dispatch({
        type: signTypes.LOGGED_REQUEST,
    });

    const token = await getToken();
    if (token) {
        dispatch(setLoggedStatus(token));
        dispatch(getData());
    }
};

export const setLoggedStatus = (_token) => async (dispatch) => {
    dispatch({
        type: signTypes.LOGGED_SUCCESS,
        _token,
        isLogged: true,
    });
};

export const logInUser = (data) => async (dispatch) => {
    dispatch({
        type: signTypes.LOGIN_REQUEST,
        user: data,
    });

    return signIn(data)
        .then((result) => {
            if (result.isLogged) {
                dispatch({
                    type: signTypes.LOGIN_SUCCESS,
                    ...result,
                });

                dispatch(getData());
            } else {
                dispatch({
                    type: signTypes.LOGIN_ERROR,
                    ...result,
                });
            }
            return result;
        })
        .catch((error) => {
            dispatch({
                type: signTypes.LOGIN_ERROR,
                error,
            });

            return error;
        });
};

export const resetPassword = (email) => async (dispatch) => {
    dispatch({
        type: signTypes.RESET_PASSWORD_REQUEST,
        email,
    });

    recoveryPassword(email)
        .then((result) => {
            return result.status === 'ok'
                ? dispatch({
                    type: signTypes.RESET_PASSWORD_SUCCESS,
                    email,
                })
                : dispatch({
                    type: signTypes.RESET_PASSWORD_ERROR,
                    error: 'niepoprawny email',
                });
        })
        .catch((error) =>
            dispatch({
                type: signTypes.RESET_PASSWORD_ERROR,
                error,
            }),
        );
};

export const signUp = (data) => async (dispatch) => {
    dispatch({
        type: signTypes.REGISTER_REQUEST,
        user: data,
    });

    dispatch({
        type: signTypes.REGISTER_RECOGNIZED_ERROR,
        email: data.email,
    });

    register(data)
        .then((result) => {
            const { data, status } = result;

            if (status === 'ok') {
                dispatch({
                    type: signTypes.REGISTER_SUCCESS,
                    ...data,
                });
            } else {
                dispatch({
                    type: signTypes.REGISTER_ERROR,
                    error: result,
                });
            }

            return result;
        })
        .catch((error) => {
            console.info('action', error);
            dispatch({
                type: signTypes.REGISTER_ERROR,
                error,
            });

            return error;
        });
};

export const saveNewPasswordToken = (token) => async (dispatch) => {
    dispatch({
        type: signTypes.SET_PASSWORD_LOADING,
        token,
    });
};

export const setNewPassword = (data) => async (dispatch) => {
    dispatch({
        type: signTypes.SET_PASSWORD_REQUEST,
        ...data,
    });

    setPassword(data)
        .then((result) => {
            const { data, status } = result;
            console.info('setNewPassword', data, status);

            if (status === 'ok') {
                dispatch({
                    type: signTypes.SET_PASSWORD_SUCCESS,
                    ...data,
                });
            } else {
                dispatch({
                    type: signTypes.RESET_PASSWORD_ERROR,
                    error: result,
                });
            }

            return result;
        })
        .catch((error) => {
            return dispatch({
                type: signTypes.RESET_PASSWORD_ERROR,
                error,
            });
        });
};

export const logout = () => async (dispatch) => {
    dispatch({
        type: signTypes.LOGOUT_REQUEST,
    });

    signOut().then(() => {
        dispatch(allClear());

    });
};
